__turbopack_context__.v({
  "bannerContainer": "_29MYIG_bannerContainer",
  "bannerImageWrapper": "_29MYIG_bannerImageWrapper",
  "cardAsset": "_29MYIG_cardAsset",
  "cardImage": "_29MYIG_cardImage",
  "cardSubtitle": "_29MYIG_cardSubtitle",
  "cardText": "_29MYIG_cardText",
  "cardTitle": "_29MYIG_cardTitle",
  "darkCard": "_29MYIG_darkCard",
  "grid": "_29MYIG_grid",
  "section": "_29MYIG_section",
});
